import { useLocation, useNavigationType } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';

export function createMemberMemory(actor) {
  let owner,
    revision = 0;
  const entries = new Map();
  const sync = () => {
    const next = actor();
    if (
      !owner ||
      owner.id !== next.id ||
      owner.token !== next.token ||
      owner.login !== next.login ||
      owner.admin !== next.admin
    ) {
      owner = next;
      revision++;
      entries.clear();
    }
    return revision;
  };
  return {
    sync,
    change(change) {
      sync();
      for (const entry of entries.values()) updateSavedMembers(entry, change);
    },
    entry(key) {
      const version = sync();
      if (!entries.has(key)) {
        entries.set(key, { version, current: () => sync() === version });
        if (entries.size > 80) entries.delete(entries.keys().next().value);
      }
      return entries.get(key);
    },
  };
}
const memory = createMemberMemory(() => {
  const s = useUserStore.getState();
  return {
    id: s.user?.id,
    login: s.isLogin,
    admin: s.isAdmin,
    token: localStorage.getItem('POSTPOP_AUTH_TOKEN'),
  };
});
useUserStore.subscribe?.(() => memory.sync());
// In-memory only: do not put member lists, search terms or credentials in web storage.
export function useMemberEntry(kind) {
  const location = useLocation(),
    type = useNavigationType();
  useUserStore((s) => s.user?.id);
  const entry = memory.entry(
    JSON.stringify([kind, location.key, location.pathname, location.search]),
  );
  return { entry, returning: type === 'POP', location };
}

export function updateSavedMembers(entry, { viewer, target, kind }) {
  const saved = entry.follow;
  if (!saved?.model) return;
  if (kind !== 'follow') {
    // Retain open/tab/scroll/focus, but never resurrect pre-block relationships.
    delete saved.model;
    return;
  }
  const same = (item) => String(item.id) === String(target.id);
  const own = saved.nickname === viewer.nickname;
  const previous = saved.model.lists.following.items.some(same);
  const lists = Object.fromEntries(
    Object.entries(saved.model.lists).map(([tab, state]) => {
      let items = state.items.map((item) => (same(item) ? { ...item, ...target } : item));
      if (own && tab === 'following') {
        items = items.filter((item) => !same(item));
        if (target.isFollowing) items.push(target);
      }
      return [tab, { ...state, items }];
    }),
  );
  const counts = { ...saved.model.counts };
  if (
    own &&
    !saved.model.lists.following.loading &&
    !saved.model.lists.following.error &&
    counts.following != null
  )
    counts.following = Math.max(
      0,
      counts.following + Number(target.isFollowing) - Number(previous),
    );
  if (saved.nickname === target.nickname && target.followersCount != null)
    counts.followers = target.followersCount;
  saved.model = { lists, counts };
}
export const syncMemberMemory = (change) => memory.change(change);
